type NarrativeRequestType = {
    componentKey: string;
    widgetId: number;
};

export interface NarrativeRequest {
    narrativeRequest?: NarrativeRequestType;
}

/**
 * Appends a `narrativeRequest` object to a payload if `isGenerativeAi` is true.
 *
 * Usage example:
 * const payload = {
 *   filter: filters,
 *   data: data,
 *   ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
 * };
 *
 * If `isGenerativeAi` is true, the resulting object will include:
 * {
 *   narrativeRequest: {
 *     componentKey: "some-key",
 *     widgetId: 123
 *   }
 * }
 * ```
 *
 * @param isGenerativeAi - Flag indicating if narrative request should be added
 * @param componentKey - The component key
 * @param widgetId - The widget ID (string or number)
 * @returns An object with or without the `narrativeRequest` key
 */
export const addNarrativeRequest = (
    isGenerativeAi: boolean | undefined,
    componentKey: string,
    widgetId: string | number | undefined,
    reportId: number | null,
) =>
    isGenerativeAi && widgetId
        ? {
              narrativeRequest: {
                  componentKey,
                  widgetId: Number(widgetId),
                  reportId,
              },
          }
        : {};
